<template>
    <div class="c-modal-wrapper c-has-dark-blue-header">
      <!-- Overlay loader -->
      <overlay-loader v-if="isLoading.length > 0"></overlay-loader>        
      <!-- Application Header -->
      <header class="c-modal-header">
        <div class="c-responsive-container">
          <div class="c-as-block c-has-header-buttons">
            <div class="c-grid-row">
              <div class="c-col-6 c-align-right">
                <button class="c-btn" v-on:click="cancelChanges()"><i aria-hidden="true" class="fa fa-times c-ux-color-danger"></i> <b>Otkaži</b></button>                
              </div>
              <div class="c-col-6 c-align-left">
                <button class="c-btn" v-on:click="saveChanges()"><i aria-hidden="true" class="fa fa-check c-ux-color-success"></i> <b>Sačuvaj</b></button>                
              </div>
            </div>
          </div>
        </div>
      </header>
      <!-- Body content -->
      <div class="c-modal-body c-has-skewed-background c-to-full-bottom">
        <div class="c-responsive-container">
          <form class="c-p-10" v-on:submit.prevent>
            <div class="c-info-title-labels-wrap">
              <button class="c-info-icon"><i class="fa fa-info-circle" aria-hidden="true"></i></button>
              <div class="c-info-title"><b>Pregled jedne rezervacije</b></div>
            </div>              
            <!-- Name, Last name -->
            <div class="c-grid-row">
              <div class="c-col-6">
                <div class="c-form-group c-blue-style">
                  <label for="guest-first-name">Ime gosta</label>
                  <input type="text" class="c-form-control" id="guest-first-name" name="guest-first-name"
                  v-model="formVars.guestFirstName.model">
                </div>
              </div>
              <div class="c-col-6">
                <div class="c-form-group c-blue-style">
                  <label for="guest-last-name">Prezime gosta</label>
                  <input type="text" class="c-form-control" id="guest-last-name" name="guest-last-name"
                  v-model="formVars.guestLastName.model">
                </div>
              </div>
            </div>          
            <!-- Nickname, Phone -->
            <div class="c-grid-row">
              <div class="c-col-6">
                <div class="c-form-group c-blue-style">
                  <label for="guest-nickname">Nadimak</label>
                  <input type="text" class="c-form-control" id="guest-nickname" name="guest-nickname"
                  v-model="formVars.guestNickname.model">
                </div>
              </div>
              <div class="c-col-6">
                <div class="c-form-group c-blue-style">
                  <label for="guest-phone-number">Telefon</label>
                  <input type="text" class="c-form-control" id="guest-phone-number" name="guest-phone-number"
                  v-model="formVars.guestPhone.model">
                </div>
              </div>
            </div>
            <!-- Guest social link -->
            <div class="c-grid-row">
              <div class="c-form-group c-blue-style">
                <label for="guest-social-link">Link ka društvenim mrežama</label>
                <div class="c-input-group">
                  <input type="text" class="c-form-control" id="guest-social-link" name="guest-social-link"
                  v-model="formVars.guestSocialLink.model">
                  <div class="c-input-addon-wrap">
                    <button class="c-addon-item"><i class="fa fa-arrow-circle-right" aria-hidden="true"></i></button>
                  </div>
                </div>
              </div>
            </div>
            <!-- Form divider -->
            <div class="c-form-divider">Dodatne opcije</div>            
            <!-- Regular Guest List -->
            <div class="c-grid-row" v-if="formVars.listOfAllRegularGuests && formVars.listOfAllRegularGuests != 'empty'">
              <div class="c-form-group c-blue-style">
                <label for="regular-guests-list">Popuni podatke sa gostom iz baze stalnih gostiju</label>
                <select class="c-form-control" id="regular-guests-list" name="regular-guests-list" v-model="formVars.selectedRegularGuest.model">
                  <option v-bind:value="null">Nije stalan gost</option>
                  <option
                    v-for="(singleGuest, key) in formVars.listOfAllRegularGuests"
                    v-bind:value="singleGuest"
                  ><span v-if="singleGuest.lastName">{{singleGuest.lastName}}</span> <span v-if="singleGuest.firstName">{{singleGuest.firstName}}</span> <span v-if="singleGuest.nickname">{{singleGuest.nickname}}</span></option>
                </select>
              </div>
            </div>
            <!-- Reservation status -->
            <!-- <div class="c-grid-row">
              <div class="c-form-group c-blue-style">
                <label for="guest-reservation-status">Čekiraj rezervaciju (potvrdi da je gost došao)</label>
                <div class="c-btn-group c-col-12">
                  <button class="c-btn c-passive-blue-btn c-col-4"><b>Čeka se</b></button>
                  <button class="c-btn c-passive-blue-btn c-col-4"><b>Došao</b></button>
                  <button class="c-btn c-passive-blue-btn c-col-4"><b>Nije došao</b></button>
                </div>                
              </div>
            </div> -->
            <!-- Switch reservations -->
            <!-- <div class="c-grid-row">
              <div class="c-form-group c-blue-style">
                <label for="guest-reservation-switch">Zameni ovu rezervaciju sa drugim stolom</label>
                <select class="c-form-control" id="guest-reservation-switch" name="guest-reservation-switch">
                  <option disabled value="null">Please select...</option>
                  <option v-for="(itemOption, index) in 3" :value="index">Select option {{index}}</option>
              </select>                
              </div>
            </div> -->
            <!-- Cancel Reservation / Clear fields  -->
            <div class="c-grid-row">
              <div class="c-form-group c-blue-style">
                <label for="drinks-revenue">Otkaži rezervaciju (očisti sve podatke iz polja)</label>
                <button class="c-btn c-passive-blue-btn c-col-12" v-on:click="clearFormData()"><i class="fa fa-ban" aria-hidden="true"></i> <b>Otkaži rezervaciju</b></button>
              </div>
            </div>
            <!-- Form divider -->
            <!-- <div class="c-form-divider">Ovaj sto je prethodno bio rezervisan za (otkazane rezervacije)</div>
            <div class="c-grid-row">
              <div class="c-ux-color-white c-fs-14">Trenutno nema nista</div>
            </div> -->
          </form>
        </div>        
      </div>
      <!-- Application Footer Menu -->
      <!-- <footer class="c-modal-footer">
        <div class="c-responsive-container c-relative c-p-0-10">
          <div class="c-grid-row c-footer-action-buttons-wrap">
            <div class="c-col-6 c-align-right">
              <button class="c-btn c-btn-default c-btn-edit-mode-round-buttons c-ux-color-success" v-on:click="saveChanges()"><i class="fa fa-check" aria-hidden="true"></i> <b>Sačuvaj</b></button>
            </div>
            <div class="c-col-6 c-align-left">
              <button class="c-btn c-btn-default c-btn-edit-mode-round-buttons c-ux-color-danger" v-on:click="cancelChanges()"><i class="fa fa-times" aria-hidden="true"></i> <b>Otkaži</b></button>
            </div>
          </div>
        </div>
      </footer> -->
    </div>
</template>

<script>
import router from '@/router/index'
import EventBus from '@/EventBus'
import OverlayLoader from "@/components/helpers/OverlayLoader";
import {firebaseDB} from '@/firebase';
export default {
  name: 'ModalSingleReservation',
  props: ['inputModalData'],
  firebase: function () {
    return {
      listOfRegularGuests: {
        source: firebaseDB.ref('listOfRegularGuests'),
        // optionally provide the cancelCallback, if the app client doesn't have permission to read from that database reference
        //cancelCallback: function (error) {console.log('!!! - IMPORTANT - cancelCallback');},
        // this is called once the data has been retrieved from firebase
        readyCallback: function (dataSnapshot) {
          this.isLoading.pop();
          this.formVars.listOfAllRegularGuests = dataSnapshot.val()
        }
      }      
    }
  },   
  components: {
      OverlayLoader: OverlayLoader
  },    
  data () {
    return {
      msg: 'ModalSingleReservation modal',
      visibleForAllisOn: false,
      selectedEventReservationsKey: null,
      selectedTableObject: null,
      isLoading: [1],
      formVars: {
        isValid: false,
        listOfAllRegularGuests: null,
        guestFirstName: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        },
        guestLastName: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        },
        guestNickname: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        },
        guestPhone: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        },
        guestSocialLink: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        },
        selectedRegularGuest: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        }
      },
      resolve: null,
      reject: null
    }
  },
  watch: {
    'formVars.selectedRegularGuest.model' : function (newValue){
      //console.log('formVars.selectedRegularGuest.model changed to: ' + JSON.stringify(newValue, null, 2));
      //console.log('regular-guest-key: ' + newValue.uid);
      this.rebindDataWithRegularGuest(newValue);
    }
  },  
  methods: {
    // ~ When we want to save changes created on this modal
    saveChanges: function (){
      var isFormValid = this.returnNewEventFormState();
      if (isFormValid){
        this.isLoading.push(1);
        firebaseDB.ref().child('/listOfAllEventsReservations/' + this.selectedEventReservationsKey + '/' + this.selectedTableObject.uid).update({
          guestFirstName: (this.formVars.guestFirstName.model) ? this.formVars.guestFirstName.model : null,
          guestLastName: (this.formVars.guestLastName.model) ? this.formVars.guestLastName.model : null,
          guestNickname: (this.formVars.guestNickname.model) ? this.formVars.guestNickname.model : null,
          guestPhone: (this.formVars.guestPhone.model) ? this.formVars.guestPhone.model : null,
          guestSocialLink: (this.formVars.guestSocialLink.model) ? this.formVars.guestSocialLink.model : null,
          regularGuestKey: (this.formVars.selectedRegularGuest.model && this.formVars.selectedRegularGuest.model.uid) ? this.formVars.selectedRegularGuest.model.uid : null
        }).then(
          function (response) {
            //console.log('Firebase Single Reservation Update succ: ' + JSON.stringify(response, null, 2));
            var resultToReturn = {
              tempMsg: 'ModalSingleReservation returns Yes'
            }
            this.resolve(resultToReturn);
          }.bind(this),
          function (error){
            console.log('Firebase Single Reservation Update ERROR: ' + JSON.stringify(error, null, 2));
          }.bind(this)
        );
      } 
    },
    returnNewEventFormState: function () {
      var returnValue = true;
      //
      return returnValue;
    },
    /////
    rebindDataWithReceivedReservation: function (inputReservationObject) {
      this.formVars.guestFirstName.model = (inputReservationObject && inputReservationObject.guestFirstName) ? inputReservationObject.guestFirstName : null;
      this.formVars.guestLastName.model = (inputReservationObject && inputReservationObject.guestLastName) ? inputReservationObject.guestLastName : null;
      this.formVars.guestNickname.model = (inputReservationObject && inputReservationObject.guestNickname) ? inputReservationObject.guestNickname : null;
      this.formVars.guestPhone.model = (inputReservationObject && inputReservationObject.guestPhone) ? inputReservationObject.guestPhone : null;
      this.formVars.guestSocialLink.model = (inputReservationObject && inputReservationObject.guestSocialLink) ? inputReservationObject.guestSocialLink : null;
      this.isLoading.pop();
    },    
    rebindDataWithRegularGuest: function (inputGuestObject) {
      this.formVars.guestFirstName.model = (inputGuestObject && inputGuestObject.firstName) ? inputGuestObject.firstName : null;
      this.formVars.guestLastName.model = (inputGuestObject && inputGuestObject.lastName) ? inputGuestObject.lastName : null;
      this.formVars.guestNickname.model = (inputGuestObject && inputGuestObject.nickname) ? inputGuestObject.nickname : null;
      this.formVars.guestPhone.model = (inputGuestObject && inputGuestObject.phone) ? inputGuestObject.phone : null;
      this.formVars.guestSocialLink.model = (inputGuestObject && inputGuestObject.socialLink) ? inputGuestObject.socialLink : null;
    },
    clearFormData: function () {
      this.formVars.guestFirstName.model = null;
      this.formVars.guestLastName.model = null;
      this.formVars.guestNickname.model = null;
      this.formVars.guestPhone.model = null;
      this.formVars.guestSocialLink.model = null;
      this.formVars.selectedRegularGuest.model = null;
    },    
    ///
    // ~ When we want to discard changes
    cancelChanges: function (){
      this.reject();
    }
  },
  created () {
    //console.log('~ created- ModalSingleReservation component!');
    if (this.inputModalData){
      //console.log('inputModalData: ' + JSON.stringify(this.inputModalData, null, 2) );
      if (this.inputModalData.dataForModal && this.inputModalData.dataForModal.selectedReservationItem){
        this.selectedTableObject = this.inputModalData.dataForModal.selectedReservationItem;
        this.rebindDataWithReceivedReservation(this.selectedTableObject);
      }
      if (this.inputModalData.dataForModal && this.inputModalData.dataForModal.eventReservationsKey){
        this.selectedEventReservationsKey = this.inputModalData.dataForModal.eventReservationsKey;
      }      
      this.resolve = this.inputModalData.resolve;
      this.reject = this.inputModalData.reject;
    }
  },
  mounted () {
    //console.log('~ mounted - ModalSingleReservation component!');
  },
  destroyed () {
    //console.log('~ destroyed- ModalSingleReservation component!');
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>



// WEBPACK FOOTER //
// src/components/futureEvents/ModalSingleReservation.vue